export default __webpack_public_path__ + "static/media/404.a12c1365.png";